export const steps = [
  {
    target: '#my-subscriptions',
    content: 'Simples e rápido. Agora você pode gerenciar as Solicitações de Reembolso que precisam da sua análise em um único lugar.',
  },
  {
    target: '#helper_request_management_button',
    content: 'Aqui você encontra mais dicas e esclarecimento para automatizar seus reembolsos e facilitar seu dia a dia.',
  },
  {
    target: '#refund-request-checkbox-0',
    content: 'Selecione as solicitações que deseja e aprove todas de uma vez.',
  },
  {
    target: '#more-icon-0',
    content: 'Veja os detalhes de cada solicitação e decida qual ação deseja tomar.',
  },
];
